//#endregion
//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { CashReconciliationFormTypes } from "models/formTypes";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function useCashReconciliationService() {
  const { apiClientInstance } = useAPIClientHelper();
  
  const getTemplate = () => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CashReconciliationClient.GetTemplate()
      .then((res) => res.data);
  };

  const get = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CashReconciliationClient.GetById(id)
      .then((res) => res.data);
  };

  const post = (cashReconciliation: ApiModels.CashReconciliationInstanceDto) => {
    return apiClientInstance(AuthEnums.AuthType.Company).CashReconciliationClient.Post(
      cashReconciliation as ApiModels.CashReconciliationInstanceDto
    );
  };

  const filter = (filter: ApiModels.CashReconciliationFilter) => {
    return apiClientInstance(AuthEnums.AuthType.Company).CashReconciliationClient.GetByFilter(filter);
  };

  const reportFilter = (baseFilter: WintUtilsWebApi.Filter, formFilter?: CashReconciliationFormTypes.Filter) => {
    return filter({
      ...baseFilter,
      ...reportToAPIFilter(formFilter),
    });
  };

  const reportToAPIFilter = (
    formFilter?: CashReconciliationFormTypes.Filter
  ): Omit<ApiModels.CashReconciliationFilter, keyof WintUtilsWebApi.Filter> => {
    return {
      includeAll: true,
      fromDate: formFilter?.date?.start,
      toDate: formFilter?.date?.end,
      ownerIds: formFilter?.registeredById ? [formFilter.registeredById] : [],
      maxDifference: formFilter?.differenceAmount?.highest,
      minDifference: formFilter?.differenceAmount?.lowest,
      maxSalesAmount: formFilter?.saleAmount?.highest,
      minSalesAmount: formFilter?.saleAmount?.lowest,
      dimensionIds: formFilter?.dimensions ?? [],
    };
  };

  const getAttachment = (id: number, attachmentId?: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CashReconciliationClient.GetAttachment(id, attachmentId)
      .then((res) => res.data);
  };

  const getStateLogs = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CashReconciliationClient.GetStateLogs(id)
      .then((data) => data.data);
  };

  const getTransactions = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CashReconciliationClient.GetTransactions(id)
      .then((res) => res.data);
  };

  return {
    getTemplate,
    get,
    post,
    filter,
    reportFilter,
    reportToAPIFilter,
    getAttachment,
    getStateLogs,
    getTransactions,
  };
}

export default useCashReconciliationService;
